import { z } from 'zod';

/**
 * API Schema for creating bank accounts (Cubix, Fedwire, Swift)
 * Endpoint: POST /fiat/create-bank-account
 */

const BankDetailsSchema = z.object({
  account_holder_address: z.object({
    address_1: z.string(),
    address_2: z.string(),
    city: z.string(),
    state: z.string(),
    postcode: z.string(),
    country: z.string(),
  }),
  bank_account_address: z.object({
    address_1: z.string(),
    address_2: z.string(),
    address_3: z.string(),
  }),
});

export const CreateBankAccountParamsSchema = z.object({
  account_holder_name: z.string(),
  bank_name: z.string(),
  account_identifier_type: z.enum([
    'iban',
    'account_number',
    'cubix_account_id',
  ]),
  account_identifier_value: z.string(),
  bank_identifier_type: z.enum([
    'bic_swift',
    'routing_number',
    'cubix_account_number_last_4_digits',
  ]),
  bank_identifier_value: z.string(),
  currency: z.string(),
  bank_details: BankDetailsSchema,
});

export const CreateBankAccountResultSchema = z.object({
  // Based on original project, this endpoint returns empty object on success
});

export type CreateBankAccountParams = z.infer<
  typeof CreateBankAccountParamsSchema
>;
export type CreateBankAccountResult = z.infer<
  typeof CreateBankAccountResultSchema
>;
